<template>
  <div>
    <h3>Copy Opportunities</h3>

    <div>
      <b-row>
        <b-col sm="10">
          
          <b-form inline @submit.prevent="" class="mb-2">
            <b-input-group class="filter-group">
              <b-input-group-prepend is-text class="semester-input-group">
                Copy From
              </b-input-group-prepend>
              <b-form-select :options="fromTerms"
                              v-model="fromTermId"
                              value-field="termId"
                              text-field="description"
                              @input="getOpportunities()"/>
            </b-input-group>

            <b-input-group class="filter-group">
              <b-input-group-prepend is-text class="semester-input-group">
                Copy To
              </b-input-group-prepend>
              <b-form-select :options="toTerms" v-model="toTermId" value-field="termId" text-field="description"/>
            </b-input-group>

            <label for="types">Type</label>
            <b-form-select id="types" v-model="opportunityTypeId" :options="opportunityTypes" value-field="opportunityTypeId" text-field="name">
              <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null">All</option>
              </template>
            </b-form-select>

            <b-input-group class="filter-group ml-2" >
              <b-input-group-prepend is-text>
                  <font-awesome-icon icon="search" />
              </b-input-group-prepend>
              <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
              <b-input-group-append>
                  <b-button @click="filter = null">Clear</b-button>
              </b-input-group-append>
            </b-input-group>    
          </b-form>
        </b-col>
        <b-col sm="2">
          <b-button class="new-opportunity-button float-right" :to="{name: 'opportunityAdd'}">
            <font-awesome-icon icon="plus" /> New Opportunity
          </b-button>
        </b-col>
      </b-row>

      <b-card no-body>
        <b-tabs card>
          <b-tab active>
            <template slot="title">
              <tab-item icon="check-circle" heading="Published" subheading=""></tab-item>
            </template>
            <div class="form-panel">
              <table-display :opportunities="filteredItems"
                             selectable
                             @filtered="onFiltered"
                             :canSave="fromTermId !== null && toTermId !== null"
                             @saveChanges="copyOpportunities"></table-display>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import termsApi from "../../api/terms";
import opportunitiesApi from "../../api/opportunity";
import TabItem from "@/components/menu/tab-item";
import TableDisplay from "@/components/opportunities/table-display";
import toastr from "toastr";
import ToastrSettings from "../../settings/toastr-settings";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      fromTerms: [],
      toTerms: [],
      fromTermId: null,
      toTermId: null,
      filter: null,
      opportunities: [],
      opportunityTypes: [],
      opportunityTypeId: null
    };
  },

  components: {
    "tab-item": TabItem,
    "table-display": TableDisplay
  },

  computed: {
    filteredItems: function() {
      var that = this;
      return _.filter(this.opportunities, item => {
        return that.filterItems(item);
      });
    }
  },

  methods: {
    filterItems(item) {
      var matchedType = this.matchType(item, this.opportunityTypeId);
      var matchedFilter = this.matchFilter(item, this.filter);

      if (matchedType && matchedFilter) {
        return true;
      }
      return false;
    },
    matchType(item, opportunityTypeId) {
      if (
        opportunityTypeId === null ||
        item.opportunityType.opportunityTypeId === opportunityTypeId
      ) {
        return true;
      }
      return false;
    },
    matchFilter(item, filter) {
      if (filter != "" && filter != null) {
        var found = this.search([item], this.filter);
        return found.length > 0;
      }
      return true;
    },
    search(collection, text) {
      var that = this;
      return _.filter(collection, function(object) {
        var search = that.deepSearch(object, text.toLowerCase());
        return _.keys(search).length > 0;
      });
    },
    deepSearch(collection, predicate, thisArg) {
      if (_.isFunction(predicate)) {
        predicate = _.iteratee(predicate, thisArg);
      } else {
        var keys = _.flatten(_.tail(arguments));
        if (typeof keys === "string") {
          keys = keys.toLowerCase();
        }
        predicate = function(val, key) {
          if (typeof val === "string") {
            val = val.toLowerCase();
          }
          return _.includes(val, keys);
        };
      }
      var that = this;
      return _.transform(collection, function(memo, val, key) {
        var include = predicate(val, key);
        if (!include && _.isObject(val)) {
          val = that.deepSearch(val, predicate);
          include = !_.isEmpty(val);
        }
        if (include) {
          _.isArray(collection) ? memo.push(val) : (memo[key] = val);
        }
      });
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getOpportunities: function() {
      var that = this;
      opportunitiesApi
        .getPublishedOpportunitiesByTerm(this.fromTermId)
        .then(function(response) {
          that.opportunities = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    copyOpportunities: function(selectedOpportunities) {
      var that = this;

      var opportunityIds = _.map(selectedOpportunities, function(opportunity) {
        return opportunity.opportunityId;
      });

      opportunitiesApi
        .postCopyOpportunities(this.toTermId, opportunityIds)
        .then(function() {
          // Toastr Message
          toastr.options = ToastrSettings;
          toastr.success("The opportunities have been copied.", "Success");

          that.getOpportunities();
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },

  created() {
    var that = this;
    opportunitiesApi.getOpportunityTypes().then(response => {
      that.opportunityTypes = response.data;
    });
    termsApi
      .getTerms()
      .then(function(response) {
        that.fromTerms = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
    termsApi
      .getCurrentAndFutureTerms()
      .then(function(response) {
        that.toTerms = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};
</script>

<style scoped>
/* .filter-group {
  max-width: 1000px;
}

.filter-group,
.new-opportunity-button {
  margin: 10px 0 15px 0;
} */

label {
  font-weight: bold;
  margin: 0 0.3em 0 1.5em;
}
.semester-input-group {
  margin-left: 10px;
}
</style>
